import Vue from 'vue'
import Router from 'vue-router'
import home from '../pages/home'
import about from '../pages/about'
import project from '../pages/project'
import news from '../pages/news'
import contact from '../pages/contact'
import projectdetail from '../pages/project-detail'
import newsdetail from '../pages/news-detail'
import recruitment from '../pages/recruitment'

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: home
    },
    {
      path: '/about',
      name: 'about',
      component: about
    },
    {
      path: '/project',
      name: 'project',
      component: project
    },
    {
      path: '/news',
      name: 'news',
      component: news
    },
    {
      path: '/contact',
      name: 'contact',
      component: contact
    }, {
      path: '/recruitment',
      name: 'recruitment',
      component: recruitment
    },
    {
      path: '/projectdetail/:id',
      name: 'projectdetail',
      component: projectdetail
    },
    {
      path: '/newsdetail/:id',
      name: 'newsdetail',
      component: newsdetail
    }
  ],
  scrollBehavior() {
    // console.log('>>>>>>>>>>');
    return { x: 0, y: 0 };
  }
})
router.beforeEach((to, from, next) => {
  window.annimatE = false
  window.annimateabout = false
  // ...
  next()

})
export default router;


// WEBPACK FOOTER //
// ./src/router/index.js